import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=764277ce&scoped=true&"
import script from "./Advice.vue?vue&type=script&lang=js&"
export * from "./Advice.vue?vue&type=script&lang=js&"
import style0 from "./Advice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Advice.vue?vue&type=style&index=1&id=764277ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764277ce",
  null
  
)

export default component.exports